import { Colors, Flex, Typography } from '@banhala/ui-kit';

type SizeAnalysisItem = { name: string; percent: number };

interface AnalysisProgressBarProps {
  size_analysis: SizeAnalysisItem[];
}

export const AnalysisProgressBar = ({
  size_analysis,
}: AnalysisProgressBarProps) => {
  return (
    <Flex gap={12}>
      {size_analysis.map((item, index) => (
        <AnalysisProgressBarItem
          key={item.name}
          title={item.name}
          percent={item.percent}
          isHighlight={index === 0}
        />
      ))}
    </Flex>
  );
};

const AnalysisProgressBarItem = ({
  title,
  percent,
  isHighlight,
}: {
  title: string;
  percent: number;
  isHighlight: boolean;
}) => {
  return (
    <Flex.Row gap={12} alignItems="center">
      <Flex width={38}>
        <Typography
          type={isHighlight ? 'subtitle2' : 'body2'}
          color={isHighlight ? 'content_blue_primary' : 'content_secondary'}
          numberOfLines={1}
        >
          {title}
        </Typography>
      </Flex>
      <Flex flex={1} height={7} borderRadius={4} backgroundColor="bg_tertiary">
        <Flex
          width={`${percent}%`}
          height={7}
          borderRadius={4}
          backgroundColorValue={
            isHighlight ? Colors.content_blue_primary : Colors.content_tertiary
          }
        />
      </Flex>
      <Flex width={38} alignItems="flex-end">
        <Typography
          type={isHighlight ? 'subtitle3' : 'body3'}
          color={isHighlight ? 'content_primary' : 'content_secondary'}
        >
          {percent}%
        </Typography>
      </Flex>
    </Flex.Row>
  );
};
